export const ROUTES = {
  main: "/",
  fakedoor: "/app",
  duitnow: "/duitnow-test",
} as const;
